import { CircleX, WifiOff } from '@/lib/icons'
import { Button } from '@/components/ui/button'
import { ApiError } from '@/lib/api'

/**
 * `components/payouts/ErrorStates.tsx` bilan BIR XIL naqsh, lekin MUSTAQIL nusxa — bu
 * modul (`components/history/`) o'z fayllariga ega, `payouts/`ga tegishga ruxsat yo'q
 * (boshqa agent egaligi). Vazifa ta'rifida "modul-lokal nusxa naqshi" deb aniq ko'rsatilgan.
 */

/** Birinchi yuklanish muvaffaqiyatsiz — hali ko'rsatadigan yozuv yo'q. */
export function HistoryRetryState({
  error,
  onRetry,
}: {
  error: Error | null
  onRetry: () => void
}) {
  const isServerError = error instanceof ApiError
  const description = isServerError
    ? (error?.message ?? 'Kutilmagan xatolik yuz berdi.')
    : "Internet aloqasini tekshiring va qayta urinib ko'ring."

  return (
    <div className="flex flex-col items-center gap-2 py-6 text-center">
      <CircleX size={22} className="text-app-hint" aria-hidden="true" />
      <p className="text-sm text-app-hint">{description}</p>
      <Button size="sm" variant="secondary" onClick={onRetry}>
        Qayta urinish
      </Button>
    </div>
  )
}

/** Yozuvlar allaqachon ekranda (masalan "Yana ko'rsatish" muvaffaqiyatsiz) — yuqori banner. */
export function HistoryErrorBanner({ error, onRetry }: { error: Error; onRetry: () => void }) {
  const isServerError = error instanceof ApiError
  return (
    <div className="flex items-center justify-between gap-3 rounded-button border border-urgency-overdue/30 bg-urgency-overdue/10 px-3 py-2 text-xs text-urgency-overdue-text">
      <span className="inline-flex items-center gap-1.5">
        <WifiOff size={13} aria-hidden="true" />
        {isServerError ? "Server bilan aloqa yo'q." : "Aloqa yo'q."} Yangi qatorlarni yuklab
        bo&apos;lmadi.
      </span>
      <button
        type="button"
        onClick={onRetry}
        className="shrink-0 font-medium underline underline-offset-2"
      >
        Qayta urinish
      </button>
    </div>
  )
}
